import { z } from "zod";

import { Tenancy } from "@/src/lib/tenancy";
import { groupSchema } from "@/src/models/group";

export enum CustomerNames {
  ENT_PARTNERS_LIVE = "ENT Partners",
  ENT_PARTNERS_SANDBOX = "ENT Partners - Test",
  HEADWAY_LIVE = "Headway",
  HEADWAY_SANDBOX = "Headway - Test",
  HVC_LIVE = "HVC",
  HVC_SANDBOX = "HVC - Test",
  MASSACHUSETTS_EAR_NOSE_AND_THROAT_ASSOCIATES_LIVE = "Massachusetts Ear, Nose and Throat Associates",
  MASSACHUSETTS_EAR_NOSE_AND_THROAT_ASSOCIATES_SANDBOX = "Massachusetts Ear, Nose and Throat Associates - Test",
  MINDPATH_LIVE = "Mindpath",
  MINDPATH_SANDBOX = "Mindpath - Test",
  PINNACLE_MEDICAL_GROUP_LIVE = "Pinnacle Medical Group",
  PINNACLE_MEDICAL_GROUP_SANDBOX = "Pinnacle Medical Group - Test",
  UNITED_VEIN_AND_VASCULAR_CENTERS_LIVE = "United Vein and Vascular Centers",
  UNITED_VEIN_AND_VASCULAR_CENTERS_SANDBOX = "United Vein and Vascular Centers - Test",
  UPPERLINE_LIVE = "Upperline",
  UPPERLINE_SANDBOX = "Upperline - Test",
  UPSTREAM_REHABILITATION_LIVE = "Upstream Rehabilitation",
  UPSTREAM_REHABILITATION_SANDBOX = "Upstream Rehabilitation - Test",
  US_HEART_AND_VASCULAR_LIVE = "US Heart and Vascular",
  US_HEART_AND_VASCULAR_SANDBOX = "US Heart and Vascular - Test",
  US_RENAL_CARE_LIVE = "US Renal Care",
  US_RENAL_CARE_SANDBOX = "US Renal Care - Test",
  US_UROLOGY_PARTNERS_LIVE = "US Urology Partners",
  US_UROLOGY_PARTNERS_SANDBOX = "US Urology Partners - Test",
  VALERIE_HEALTH_INC_LIVE = "Valerie Health Inc",
  VALERIE_HEALTH_INC_SANDBOX = "Valerie Health Inc - Test",
  QOROS_LIVE = "Qoros",
  QOROS_SANDBOX = "Qoros - Test",
  NIMBUS_LIVE = "Nimbus",
  NIMBUS_SANDBOX = "Nimbus - Test",
  NIRA_LIVE = "Nira",
  NIRA_SANDBOX = "Nira - Test",
  AUTONOMY_LIVE = "Autonomy Health",
  AUTONOMY_SANDBOX = "Autonomy Health - Test",
  PEDIATRIC_ASSOCIATES_LIVE = "Pediatric Associates",
  PEDIATRIC_ASSOCIATES_SANDBOX = "Pediatric Associates - Test",
  SPORTORTHO_LIVE = "SportOrtho",
  SPORTORTHO_SANDBOX = "SportOrtho - Test",
  STRIDECARE_LIVE = "StrideCare",
  STRIDECARE_SANDBOX = "StrideCare - Test",
  VNA_LIVE = "VNA",
  VNA_SANDBOX = "VNA - Test",
  TEXAS_HEART_LIVE = "Texas Heart",
  TEXAS_HEART_SANDBOX = "Texas Heart - Test",
  INSIGHT_LIVE = "Insight",
  INSIGHT_SANDBOX = "Insight - Test",
  SIENT_LIVE = "SIENT",
  SIENT_SANDBOX = "SIENT - Test",
  BALANCE_HEALTH_LIVE = "Balance Health",
  BALANCE_HEALTH_SANDBOX = "Balance Health - Test",
  NVISION_LIVE = "NVISION",
  NVISION_SANDBOX = "NVISION - Test",
}

export enum CustomerIds {
  ENT_PARTNERS_LIVE = "cf42e5c5-8fd6-40b3-9ed8-7329c2e4b046",
  ENT_PARTNERS_SANDBOX = "6c382804-6a44-4368-a910-2875ac4247bb",
  HEADWAY = "14611b0f-20eb-4532-83f5-f1ce472e2c07",
  HEADWAY_SANDBOX = "a035b593-a550-4317-817d-3fed1d6b2e76",
  MASSACHUSETTS_EAR_NOSE_AND_THROAT_ASSOCIATES_LIVE = "97ecdcce-ae90-4983-a27e-ad5cd431894b",
  MASSACHUSETTS_EAR_NOSE_AND_THROAT_ASSOCIATES_SANDBOX = "543450ba-d5af-4267-97d9-41c5a8ac5172",
  MINDPATH_LIVE = "da4edf41-83ca-44da-ac1b-4732a8ef0d10",
  MINDPATH_SANDBOX = "952e198f-a9dd-4cdb-b985-48c8a575a591",
  PINNACLE_MEDICAL_GROUP_LIVE = "e308d82f-bea0-43d7-970b-6398f19eddfc",
  PINNACLE_MEDICAL_GROUP_SANDBOX = "9dac2f08-896b-4643-aeb4-73a6bcfc1894",
  UNITED_VEIN_AND_VASCULAR_CENTERS_LIVE = "3b1847b9-ce0d-45d1-9ba9-20e37632de44",
  UNITED_VEIN_AND_VASCULAR_CENTERS_SANDBOX = "cf227a9d-a5e5-46da-9469-f29072beae6c",
  UPPERLINE_LIVE = "9f7d34ee-db61-4c7a-a28a-a7a8db0a7801",
  UPPERLINE_SANDBOX = "1ddedaf8-ac5e-480d-85ac-19c5c4708ec9",
  UPSTREAM_REHABILITATION_LIVE = "9fcb3ad7-2f71-437e-9aab-31b8850e8ab8",
  UPSTREAM_REHABILITATION_SANDBOX = "328ca201-854b-4196-b63e-062019d7e825",
  US_HEART_AND_VASCULAR_LIVE = "5def7b98-8e73-479d-9c7c-804109cc29e9",
  US_HEART_AND_VASCULAR_SANDBOX = "b4b5e0a2-4531-46ac-9b2f-eac33a01efb0",
  US_RENAL_CARE_LIVE = "4be18d3b-0c0f-4441-a6e9-0eb0c69affdd",
  US_RENAL_CARE_SANDBOX = "6582f2db-9739-49e0-9dad-87a7cd835769",
  US_UROLOGY_PARTNERS_LIVE = "a6c3a5ab-1848-44f8-8ad2-992bcbb559ff",
  US_UROLOGY_PARTNERS_SANDBOX = "60aa9686-0f13-4d57-9534-f81067471c7f",
  VALERIE_HEALTH_INC_LIVE = "ba64adad-60a3-4a7a-a6f4-8467937709a2",
  VALERIE_HEALTH_INC_SANDBOX = "0758a8ca-3a9c-4ec0-a4a5-ea01a09c1b82",
  HVC_LIVE = "e9211123-4adb-4da4-8a16-40e2bc6868c4",
  HVC_SANDBOX = "b0c61e22-df6f-46f0-8104-cdc1d26d6a70",
  QOROS_LIVE = "9bb807a8-7d82-4713-86f5-6cd7a706857d",
  QOROS_SANDBOX = "513bd393-8382-4d2d-a642-dc611c29f166",
  NIMBUS_LIVE = "7a425718-85e4-4325-a51d-4d44e0433b11",
  NIMBUS_SANDBOX = "ee45866f-59de-4857-8a1f-bd4b0f91b462",
  NIRA_LIVE = "d03fe6cd-2013-4870-9f20-a70e0b85162d",
  NIRA_SANDBOX = "641bb34a-9dde-4022-8192-d7ec46c0540e",
  AUTONOMY_LIVE = "6e7477e7-8675-483a-bfb2-8e2db333a376",
  AUTONOMY_SANDBOX = "ef95345f-d686-4a08-afaa-d938b2fdfaaf",
  PEDIATRIC_ASSOCIATES_LIVE = "f079f7b3-b92f-4471-bfe0-5faf2c9bcfa6",
  PEDIATRIC_ASSOCIATES_SANDBOX = "99084f30-0b12-4559-a23b-a63437b92777",
  SPORTORTHO_LIVE = "3e208e38-9781-479e-9bc3-7e41ed762346",
  SPORTORTHO_SANDBOX = "2cce056d-b402-4294-8108-54951edab414",
  STRIDECARE_LIVE = "02646e0b-ad11-4750-9768-f0633532cc61",
  STRIDECARE_SANDBOX = "5237ae81-1a68-4647-a6a2-fc8dc2e4da36",
  VNA_LIVE = "48880fa8-195f-43b3-ad3e-5833fa9dadec",
  VNA_SANDBOX = "d6c73a79-bfbc-45f5-aac8-47e80bf1d01d",
  TEXAS_HEART_LIVE = "de33e5f0-19ce-451b-8a1e-58db6c4c8438",
  TEXAS_HEART_SANDBOX = "39c3c9ea-4dd9-4f28-927a-99af23b03733",
  INSIGHT_LIVE = "503d211d-08c7-435d-af01-d3dbe87cf90b",
  INSIGHT_SANDBOX = "3e7b5a7c-d5fb-4289-90bc-34025ae3a0ea",
  SIENT_LIVE = "02a533f2-517c-450b-a620-940159bdba03",
  SIENT_SANDBOX = "c7dbb9a9-fa90-4e34-ae7a-8ce29ea44ecc",
  BALANCE_HEALTH_LIVE = "40acf397-1ec1-4077-8d2a-74eef7e19fde",
  BALANCE_HEALTH_SANDBOX = "d786db0a-e2ab-40d3-a61f-d634611195da",
  PACESETTER_LIVE = "389788b6-db70-4bbe-ac77-e9bffd75f3ec",
  PACESETTER_SANDBOX = "d4ba88d9-bc12-49f6-851e-b9b49e0dc1b3",
  NVISION_LIVE = "b209905c-e62b-4f80-af55-a6e96798d682",
  NVISION_SANDBOX = "22db745c-dd6e-4e7c-b9df-d7838c74ddf8",
  TRICITY_LIVE = "5f1bf34f-8bf1-4c29-b7e8-14c73b8f27fa",
  TRICITY_SANDBOX = "0d3365db-f903-440b-aac5-ca511a7316b3",
}

export enum CustomerSubdomains {
  ENT_PARTNERS_LIVE = "entp",
  ENT_PARTNERS_SANDBOX = "entp-sandbox",
  HEADWAY_LIVE = "headway",
  HEADWAY_SANDBOX = "headway-sandbox",
  HVC_LIVE = "hvc",
  HVC_SANDBOX = "hvc-sandbox",
  MASSACHUSETTS_EAR_NOSE_AND_THROAT_ASSOCIATES_LIVE = "massent",
  MASSACHUSETTS_EAR_NOSE_AND_THROAT_ASSOCIATES_SANDBOX = "massent-sandbox",
  MINDPATH_LIVE = "mindpath",
  MINDPATH_SANDBOX = "mindpath-sandbox",
  PINNACLE_MEDICAL_GROUP_LIVE = "pinnacle",
  PINNACLE_MEDICAL_GROUP_SANDBOX = "pinnacle-sandbox",
  UNITED_VEIN_AND_VASCULAR_CENTERS_LIVE = "uvvc",
  UNITED_VEIN_AND_VASCULAR_CENTERS_SANDBOX = "uvvc-sandbox",
  UPPERLINE_LIVE = "upperline",
  UPPERLINE_SANDBOX = "upperline-sandbox",
  UPSTREAM_REHABILITATION_LIVE = "upstream",
  UPSTREAM_REHABILITATION_SANDBOX = "upstream-sandbox",
  US_HEART_AND_VASCULAR_LIVE = "ushv",
  US_HEART_AND_VASCULAR_SANDBOX = "ushv-sandbox",
  US_RENAL_CARE_LIVE = "usrc",
  US_RENAL_CARE_SANDBOX = "usrc-sandbox",
  US_UROLOGY_PARTNERS_LIVE = "usro",
  US_UROLOGY_PARTNERS_SANDBOX = "usro-sandbox",
  VALERIE_HEALTH_INC_LIVE = "vh",
  VALERIE_HEALTH_INC_SANDBOX = "vh-sandbox",
  QOROS_LIVE = "qoros",
  QOROS_SANDBOX = "qoros-test",
  NIRA_LIVE = "nira",
  NIRA_SANDBOX = "nira-sandbox",
  NIMBUS_HEALTH_LIVE = "nimbushealth",
  NIMBUS_HEALTH_SANDBOX = "nimbushealth-sandbox",
  AUTONOMY_LIVE = "autonomy-health",
  AUTONOMY_SANDBOX = "autonomy-health-sandbox",
  PEDIATRIC_ASSOCIATES_LIVE = "pediatricassociates",
  PEDIATRIC_ASSOCIATES_SANDBOX = "pediatricassociates-sandbox",
  SPORTORTHO_LIVE = "sportortho",
  SPORTORTHO_SANDBOX = "sportortho-test",
  STRIDECARE_LIVE = "stridecare",
  STRIDECARE_SANDBOX = "stridecare-test",
  VNA = "vna",
  VNA_SANDBOX = "vna-sandbox",
  TEXAS_HEART_LIVE = "south-heart",
  TEXAS_HEART_SANDBOX = "south-texas-test",
  INSIGHT_LIVE = "insight",
  INSIGHT_SANDBOX = "insight-sandbox",
  SIENT_LIVE = "sient",
  SIENT_SANDBOX = "sient-sandbox",
  BALANCE_HEALTH_LIVE = "balance-health",
  BALANCE_HEALTH_SANDBOX = "balance-health-sandbox",
  NVISION_LIVE = "NVISION",
  NVISION_SANDBOX = "NVISION-sandbox",
}

export const customerSchema = z.object({
  id: z.string(),
  name: z.nativeEnum(CustomerNames),
  createdAt: z.string(),
  updatedAt: z.string().nullable(),
  deletedAt: z.string().nullable(),
  tenancy: z.nativeEnum(Tenancy),
  stytchOrgId: z.string(),
  subdomain: z.nativeEnum(CustomerSubdomains),
  group: z.array(groupSchema),
});

export type Customer = z.infer<typeof customerSchema>;

export const customerShape: Customer = {
  id: "",
  name: CustomerNames.VALERIE_HEALTH_INC_LIVE,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  tenancy: Tenancy.LIVE,
  stytchOrgId: "",
  subdomain: CustomerSubdomains.VALERIE_HEALTH_INC_LIVE,
  group: [],
};
